import { Link } from 'react-router-dom'

import { Tag } from '../types'

type IntroSegment = Readonly<{
  text: string
  href?: string
}>

type SeoIntro = Readonly<{
  paragraphs: readonly (readonly IntroSegment[])[]
  facts?: readonly string[]
  source?: string
  sourceLabel?: string
}>

const isInternal = (href?: string): href is string => Boolean(href && href.startsWith('/') && !href.startsWith('//'))

const isWikipedia = (href?: string): href is string => Boolean(href && /^https:\/\/(?:ja|en)\.wikipedia\.org\//.test(href))

const setIntroTitle = (tag: Tag, language: string): string => {
  const english = tag.nameEn ?? tag.nameJa ?? ''
  if (language === 'ja') return tag.nameJa || english
  return tag.nameEn || english
}

const showSetIntro = (tag: Tag | undefined, isPokemon: boolean): tag is Tag & { seoIntro: SeoIntro } => {
  return Boolean(tag && !isPokemon && tag.seoIntro && tag.seoIntro.paragraphs.length > 0)
}

const SetIntro = ({ title, intro }: { title: string, intro: SeoIntro }): JSX.Element => {
  return (
    <section className='set-intro'>
      <h1>{ title }</h1>
      {
        intro.paragraphs.map((paragraph, index) => (
          <p key={ index }>
            {
              paragraph.map((segment, segmentIndex) => (
                isInternal(segment.href)
                  ? <Link key={ segmentIndex } to={ segment.href }>{ segment.text }</Link>
                  : <span key={ segmentIndex }>{ segment.text }</span>
              ))
            }
          </p>
        ))
      }
      {
        intro.facts && intro.facts.length > 0
          ? <ul>
            { intro.facts.map(fact => <li key={ fact }>{ fact }</li>) }
          </ul>
          : null
      }
      {
        isWikipedia(intro.source)
          ? <p className='set-intro-source'><a href={ intro.source } rel='nofollow noreferrer'>{ intro.sourceLabel || '参考' }</a></p>
          : null
      }
    </section>
  )
}

export { SetIntro, setIntroTitle, showSetIntro }
export type { SeoIntro }
